import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { caseStudies } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const CaseStudies = () => {
  return (
    <section id="case-studies" className="py-24 bg-[#101F27] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-base md:text-lg font-semibold text-[#009688] uppercase tracking-wide mb-4">
            Case Studies
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Proof in The{' '}
            <span className="text-white">
              Wristband
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Discover how WristCoin has transformed operations across different industries
          </p>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {caseStudies.slice(0, 3).map((study, index) => (
            <Card
              key={index}
              className="bg-[#37464F]/50 border-gray-800 hover:border-[#009688]/50 transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={study.image}
                  alt={study.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#101F27] to-transparent"></div>
              </div>

              <CardContent className="p-6">
                <div className="mb-2">
                  <h3 className="text-xl font-bold text-white">{study.title}</h3>
                  <p className="text-sm text-[#009688]">{study.location}</p>
                </div>

                <div className="space-y-3 mb-4">
                  <div>
                    <span className="text-xs font-semibold text-gray-500 uppercase">Challenge</span>
                    <p className="text-sm text-gray-400">{study.challenge}</p>
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-gray-500 uppercase">Result</span>
                    <p className="text-sm text-gray-300">{study.result}</p>
                  </div>
                </div>

                {study.link ? (
                  <Link
                    to={study.link}
                    className="text-[#009688] text-sm font-semibold hover:underline inline-flex items-center group"
                  >
                    Read Full Case Study
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                ) : (
                  <button className="text-[#009688] text-sm font-semibold hover:underline flex items-center group">
                    Read Full Case Study
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* View All CTA */}
        <div id="case-studies-cta" className="text-center mt-12 space-y-3">
          <div>
            <Link to="/case-studies" className="text-[#009688] font-semibold hover:underline">
              View All Case Studies →
            </Link>
          </div>
          <div>
            <Link to="/blog" className="text-[#009688] font-semibold hover:underline" data-testid="blog-link">
              Behind the Tap: Blog Posts →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
